import {Typography} from '~library/atoms/Typography';

export const CommentButton = (props) => {
  const {handleCommentClick, post, dataQaId} = props;

  const {replyIds, replies} = post;
  const commentCount = Array.isArray(replyIds) ? replyIds.length : Object.keys(replies).length;

  const handleClick = () => {
    handleCommentClick();
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="unstyled-button wic__guest-post-interact-button"
      data-qa-id={dataQaId}
    >
      <Typography variant="paragraph4">
        {commentCount === 1 ? '1 Comment' : `${commentCount} Comments`}
      </Typography>
    </button>
  );
};
